import { AccrualDocumentExtraction } from "@common/dto/financialDocument/accrual-document-extraction.schema";
import { AccrualDocumentImporterMode } from "./accrualDocumentImporter.lib";

export interface AccrualPartyHints {
    name: string | null;
    names: string[];
    emails: string[];
    phoneNumbers: string[];
    addresses: string[];
}

export const EMPTY_PARTY_HINTS: AccrualPartyHints = {
    name: null,
    names: [],
    emails: [],
    phoneNumbers: [],
    addresses: [],
};

function dedupeNonEmptyValues(values: string[]): string[] {
    const seen = new Set<string>();
    const deduped: string[] = [];

    for (const rawValue of values) {
        const trimmedValue = rawValue.trim();
        if (!trimmedValue) {
            continue;
        }

        const normalizedValue = trimmedValue.toLowerCase();
        if (seen.has(normalizedValue)) {
            continue;
        }

        seen.add(normalizedValue);
        deduped.push(trimmedValue);
    }

    return deduped;
}

export function getPartyHintsFromOriginalExtraction({
    originalExtraction,
    orderIndex,
    mode,
}: {
    originalExtraction: AccrualDocumentExtraction | null | undefined;
    orderIndex: number;
    mode: AccrualDocumentImporterMode;
}): AccrualPartyHints {
    const document = originalExtraction?.documents[orderIndex];
    if (!document) {
        return EMPTY_PARTY_HINTS;
    }

    const partyIdentifiers =
        mode === "bills" ? document.issuer : document.recipient;
    const identifierNames = partyIdentifiers?.names ?? [];
    const counterpartyName = document.counterpartyName?.trim() ?? null;

    const names = dedupeNonEmptyValues([
        ...identifierNames,
        ...(counterpartyName ? [counterpartyName] : []),
    ]);

    const emails = dedupeNonEmptyValues(partyIdentifiers?.emails ?? []);
    const phoneNumbers = dedupeNonEmptyValues(
        partyIdentifiers?.phoneNumbers ?? [],
    );
    const addresses = dedupeNonEmptyValues(partyIdentifiers?.addresses ?? []);
    const primaryName = names[0] ?? counterpartyName;

    return {
        name: primaryName || null,
        names,
        emails,
        phoneNumbers,
        addresses,
    };
}
